import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';
import { setSnackBar } from '../../states/app/staticSlice';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function usePaymentStatus(userId) {
  const dispatch = useDispatch();
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    userId ? '/paymentstatuses/' : null,
    (url) => fetcher(url),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  useEffect(() => {
    const errorStatus = error?.response?.status;
    const hasPaymentStatuses = Boolean(data?.data);

    if (errorStatus >= 400 && !hasPaymentStatuses) {
      const messageError = `Error: ${error?.response?.status} - ${error?.response?.statusText}: OrderStatus`;
      dispatch(
        setSnackBar({ open: true, message: messageError, color: 'error' })
      );
    }
  }, [error, data, dispatch]);

  return {
    data: data,
    res: {
      status: data?.code || error?.response?.status,
      statusText: data?.message || error?.response?.statusText,
    },
    isLoading: isLoading,
    isValidating: isValidating,
    mutate: mutate,
  };
}

export default usePaymentStatus;
